import React,{useState,useEffect} from 'react';
import Card from './Card/Card';
import axios from 'axios';
import {Link} from 'react-router-dom';
import css from './Card/Card.module.css';
import Spinner from '../Spinner/Spinner';


function ListProduct(props) {
    const [productsBySell, setProductsBySell] = useState([]);
    const [productsByArrival, setProductsByArrival] = useState([]);
    const [categories, setCategories] = useState([]);
    const [error,setError] = useState('');
    const [loading,setLoading] =useState(true);
    const fetchProductBySell =()=>{
        axios.get('/products?sortBy=sold&order=desc&limit=5')
        .then(products=>{
            setProductsBySell(products.data);
        }).catch(err=>{
            setError(err.response.data.message);
        })
    };

    const fetchproductsByArrival =()=>{
        axios.get('/products?sortBy=createdAt&order=desc&limit=5')
        .then(products=>{
            setProductsByArrival(products.data);
        }).catch(err=>{
            setError(err.response.data.message);
        })
    };
    const getCategorys =(fn)=>{
        axios.get('/categorys')
        .then(cats=>{
             setCategories(cats.data.cates)
             setLoading(false);
        })
        .catch(err=>{
            console.log(err);
        });
    };      
        
    useEffect(()=>{
            fetchProductBySell();
            fetchproductsByArrival();
            getCategorys();
    },[]);

    return (
        <React.Fragment>
       
        <br/>
            <div className="row">
                <div className="col-lg-12">
                <h2 className="mb-4 text-center">Thực phẩm chức năng - Dược mỹ phẩm</h2>
                        <div className="row justify-content-center">
                            
                            {(loading&&(<Spinner/>))||(categories.map((cate, i) => (
                                <div key={i} className="col-xs-6 col-sm-4 col-md-3 col-lg-2 mb-3 " >
                                    <div className={`${css.Cardcate} justify-content-center card h-100`}>
                                        <img className={`${css.Image} card-img-top mx-auto`} src={`https://nhathuocvantien.herokuapp.com/api/product/photo/${cate.image}`} alt={cate.name}/>
                                        {/* <p className="text-center text-muted">{console.log(count)+" sản phẩm"}</p> */}
                                        <p className="text-center h6"><Link style={{fontSize:"13px"}} className="text-center text-uppercase" to={`/category/${cate._id}`}>{cate.name}</Link></p>
                                        </div>    
                                </div>
                            )))}
                        </div>
                    <h2 className="mb-4 text-center">Sản Phẩm Mới Nhất</h2>
                    <hr/>
                        <div className="row justify-content-center">
                            {productsByArrival.map((product, i) => (
                                <div key={i} className="col-xs-6 col-sm-4 col-md-3 col-lg-2 mb-3">
                                    <Card  product={product} />
                                </div>
                            ))}
                        </div>
                    
                    <h2 className="mb-4 text-center">Bán Chạy Nhất</h2>
                    <hr/>
                    <div className="row justify-content-center">
                        {productsBySell.map((product, i) => (
                            <div key={i} className="col-xs-6 col-sm-4 col-md-3 col-lg-2 mb-3 mb-3">
                                <Card  product={product}/>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <br/>
       
    </React.Fragment>
    );
}

export default ListProduct;